function resolveApiBaseUrl() {
  const envBase = typeof process !== 'undefined' ? process.env.REACT_APP_API_BASE_URL : undefined;
  if (envBase) return String(envBase).replace(/\/$/, '');

  try {
    const host = window && window.location && window.location.hostname ? String(window.location.hostname) : '';
    if (host === 'localhost' || host === '127.0.0.1') return 'http://localhost:4000';
  } catch (_) {
    // ignore
  }

  return 'https://api.aryahomeohall.com';
}

function getToken() {
  try {
    return window.localStorage.getItem('ADMIN_TOKEN') || '';
  } catch (_) {
    return '';
  }
}

function setToken(token) {
  try {
    window.localStorage.setItem('ADMIN_TOKEN', String(token || ''));
  } catch (_) {
    // ignore
  }
}

function clearToken() {
  try {
    window.localStorage.removeItem('ADMIN_TOKEN');
  } catch (_) {
    // ignore
  }
}

async function apiRequest(path, { method = 'GET', body, headers } = {}) {
  const base = resolveApiBaseUrl();
  const url = `${base}/api${path.startsWith('/') ? '' : '/'}${path}`;

  const token = getToken();

  const res = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(headers || {}),
    },
    body: typeof body === 'undefined' ? undefined : JSON.stringify(body),
  });

  let json;
  try {
    json = await res.json();
  } catch (_) {
    json = null;
  }

  if (!res.ok || !json || json.success !== true) {
    if (res.status === 401) {
      clearToken();
    }
    const msg = (json && json.message) ? json.message : `Server error (${res.status})`;
    const err = new Error(msg);
    err.status = res.status;
    err.payload = json;
    throw err;
  }

  return json;
}

async function apiGet(path, options) {
  const json = await apiRequest(path, { ...(options || {}), method: 'GET' });
  return json.data;
}

async function apiPost(path, body, options) {
  const json = await apiRequest(path, { ...(options || {}), method: 'POST', body });
  return json;
}

async function apiPut(path, body, options) {
  const json = await apiRequest(path, { ...(options || {}), method: 'PUT', body });
  return json;
}

async function apiPatch(path, body, options) {
  const json = await apiRequest(path, { ...(options || {}), method: 'PATCH', body });
  return json;
}

async function apiDelete(path, options) {
  const json = await apiRequest(path, { ...(options || {}), method: 'DELETE' });
  return json;
}

async function apiLogin(email, password) {
  const json = await apiPost('/auth/login', { email, password });
  const token = json && json.data && json.data.token ? String(json.data.token) : '';
  if (token) setToken(token);
  return json;
}

export { apiGet, apiPost, apiPut, apiPatch, apiDelete, apiLogin, setToken, clearToken, getToken };
